













import Vue from "vue";
import SideBar from "@/components/SideBar.vue";

export default Vue.extend({
    components: {
        SideBar
    }
});
